<app-single-detail
  svgIcon="feather:box"
  label="Container type"
  [value]="containerDetails?.containerTypeName"></app-single-detail>
<app-single-detail svgIcon="feather:user" label="Client" [value]="containerDetails?.clientName"></app-single-detail>
<app-single-detail
  svgIcon="hero_outline:office-building"
  label="Site"
  [value]="containerDetails?.siteName"></app-single-detail>
<app-single-detail
  svgIcon="feather:crosshair"
  label="Location"
  [value]="containerDetails?.locationCode"></app-single-detail>
<app-single-detail
  svgIcon="feather:codesandbox"
  label="Container capacity"
  [value]="containerDetails?.containerCapacity"></app-single-detail>
<app-single-detail
  svgIcon="feather:hexagon"
  label="Remaining capacity"
  [value]="containerDetails?.remainingCapacity"></app-single-detail>
